export default class CompanyOverview {
  constructor() {
    this.time_spent_this_month = []
  }
}
